import { ref } from 'vue'

const ADMIN_ROLES = ['dev', 'RB Admin User']

const isAdmin = ref(false)
const checked = ref(false)

export function useAdminStatus() {
  async function checkAdminStatus() {
    if (checked.value) return isAdmin.value

    let roleName = null
    let roleId = 0
    try {
      const raw = localStorage.getItem('userData')
      if (raw && raw !== 'undefined') {
        const user = JSON.parse(raw)

        roleName = user?.role?.name ?? null
        roleId = Number(user?.role_id || user?.role?.id || 0)
      }
    } catch {
      roleName = null
      roleId = 0
    }

    if (!roleName && roleId !== 2) {
      isAdmin.value = false

      return false
    }

    const syncStatus = getAdminStatusSync()
    if (!syncStatus.isAdmin) {
      isAdmin.value = false
      checked.value = true

      return false
    }

    try {
      const response = await fetch('/api/admin/check', {
        headers: { Accept: 'application/json' },
      })

      isAdmin.value = response.ok
    } catch {
      isAdmin.value = false
    }

    checked.value = true
    
    return isAdmin.value
  }

  function resetAdminStatus() {
    checked.value = false
    isAdmin.value = false
  }

  return {
    isAdmin,
    checked,
    checkAdminStatus,
    resetAdminStatus,
  }
}

/**
 * Synchronous getter for nav filtering / route guards.
 * Reads role from localStorage — same pattern as getControlCenterAccessSync().
 * Falls back to the reactive ref if localStorage is unavailable.
 */
export function getAdminStatusSync() {
  try {
    const raw = localStorage.getItem('userData')
    if (!raw || raw === 'undefined') return { isAdmin: isAdmin.value }

    const user = JSON.parse(raw)
    const roleName = user?.role?.name ?? null
    const roleId = Number(user?.role_id || user?.role?.id || 0)

    if (roleName && ADMIN_ROLES.includes(roleName)) {
      return { isAdmin: true }
    }

    if (roleId === 2) {
      return { isAdmin: true }
    }

    return { isAdmin: false }
  } catch {
    return { isAdmin: isAdmin.value }
  }
}
